import React from "react";
import { galleryImg } from "./GalleryFiles";

function GalleryPage1() {
  const firstPageImgs = galleryImg.filter((item) => item.id <= 8);
  return (
    <>
      <div className="grid grid-cols-3 gap-7 md1000:grid-cols-2 min540:grid-cols-1">
        {firstPageImgs.map((image) => (
          <div
            key={image.id}
            className="w-full h-[240px] flex items-center justify-center"
          >
            <img
              src={image.img}
              alt={image.alt}
              className="w-100 h-80 rounded-lg shadow-lg mb-4"
            />
          </div>
        ))}
      </div>
    </>
  );
}

export default GalleryPage1;